<template>
  <div class="add_accident">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">{{
          isAddType ? '新增事故信息' : '编辑事故信息'
        }}</template>
      </QS-h3-title>
      <div class="splitline mt16 mb16" />
      <el-collapse v-model="activeNames" style="min-width: 1080px">
        <el-form
          class="infor"
          :label-width="labelWidth"
          :rules="rules"
          :model="accidentForm"
          ref="sourceList"
        >
          <el-collapse-item title="基本信息" name="1">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="车牌号:" prop="carId">
                  <CarSelect
                    v-if="isAddType"
                    :modelValue="accidentForm.carId"
                    :getCarDetail="true"
                    :plateNo="accidentForm.plateNo"
                    :getListParams="{ state: 2 }"
                    :disabled="isEditType"
                    @update:modelValue="val => { accidentForm.carId = val }"
                    @change="selectPlateNo">
                  </CarSelect>
                  <span v-else>{{accidentForm.plateNo}}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-for="item in list.slice(0, 2)"
                :key="item.key"
              >
                <el-form-item :label="item.name + ':'">{{
                  accidentForm[item.key] || '--'
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8" v-for="item in list.slice(2)" :key="item.key">
                <el-form-item :label="item.name + ':'">{{
                  accidentForm[item.key] || '--'
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="报案日:" prop="reportDate">
                  <el-date-picker
                    v-model="accidentForm.reportDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="reportDataOption"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="claimState" label="出险状态:">
                  <el-select
                    placeholder="请选择"
                    v-model="accidentForm.claimState"
                    clearable
                  >
                    <el-option
                      v-for="item in outInsuranceStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出险日期:" prop="accidentDate">
                  <el-date-picker
                    v-model="accidentForm.accidentDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="accidentDateOption"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="事故类型:" prop="accidentType">
                  <el-select
                    placeholder="请选择"
                    v-model="accidentForm.accidentType"
                    clearable
                  >
                    <el-option
                      v-for="item in accidentTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="事故状态:" prop="accidentStatus">
                  <el-select
                    :disabled="isSettlement"
                    placeholder="请选择"
                    v-model="accidentForm.accidentStatus"
                    clearable
                  >
                    <el-option
                      v-for="item in accidentStatusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="事故责任:" prop="accidentBlame">
                  <el-select
                    placeholder="请选择"
                    v-model="accidentForm.accidentBlame"
                    clearable
                  >
                    <el-option
                      v-for="item in accidentResponsibilityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item
            :title="`${
              activeNames.includes('2') ? '收起' : '展开'
            }(以下内容为选填)`"
            name="2"
          >
            <div class="mt16">
              <el-row :gutter="20">
                <!-- 保险类型 -->
                <el-col :span="8">
                  <el-form-item label="保险类型:" prop="insuranceType">
                    <el-select
                      placeholder="请选择"
                      v-model="accidentForm.insuranceType"
                      clearable
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in insuranceTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 定损金额 -->
                <el-col :span="8">
                  <el-form-item label="定损金额:" prop="lossAmount">
                    <el-input
                      v-model="accidentForm.lossAmount"
                      placeholder="请输入"
                      v-limit-money="true"
                      v-delete-emoji
                      :disabled="
                        isSettlement && +accidentForm.accidentStatus === 3
                      "
                      @change="lossAmountChange"
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- 理赔金额 -->
                <el-col :span="8">
                  <el-form-item label="理赔金额:" prop="claimAmount">
                    <el-input
                      v-model="accidentForm.claimAmount"
                      placeholder="请输入"
                      v-delete-emoji
                      v-limit-money
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="免赔金额:" prop="deductibleAmount">
                    <el-input
                      v-model="accidentForm.deductibleAmount"
                      placeholder="请输入"
                      v-delete-emoji
                      v-limit-money
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="车辆维修金额:">
                    <el-input
                      v-model="accidentForm.repairAmount"
                      placeholder="请输入"
                      v-delete-emoji
                      v-limit-money
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- 应收金额 -->
                <el-col :span="8">
                  <el-form-item label="应收金额:" prop="receivableAmount">
                    <el-input
                      v-model="accidentForm.receivableAmount"
                      placeholder="请输入"
                      v-limit-money="true"
                      :disabled="rowLength > 0"
                      v-delete-emoji
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- 客户承担担保金额： -->
                <el-col :span="8">
                  <el-form-item
                    prop="customerInsuredAmount"
                    label="客户承担担保金额:"
                  >
                    <el-input
                      v-model="accidentForm.customerInsuredAmount"
                      placeholder="请输入"
                      v-limit-money="true"
                      v-delete-emoji
                    >
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- 事故地点 -->
                <el-col :span="8">
                  <el-form-item label="事故地点:" prop="accidentPlace">
                    <el-input
                      v-model.trim="accidentForm.accidentPlace"
                      placeholder="请输入"
                      maxlength="500"
                      v-delete-emoji
                      v-unspace
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 事故原因 -->
                <el-col :span="8">
                  <el-form-item label="事故原因:">
                    <el-select
                      v-model="accidentForm.accidentCauseCode"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in accidentReasonList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!-- 事故-是否人伤 -->
                <el-col :span="8">
                  <el-form-item label="是否人伤:">
                    <el-select
                      v-model="accidentForm.injurySituationCode"
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in accidentPersonInjuryList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 事故单号 -->
                <el-col :span="8">
                  <el-form-item label="事故单号:" prop="accidentNumber">
                    <el-input
                      v-model.trim="accidentForm.accidentNumber"
                      placeholder="请输入"
                      maxlength="30"
                      @input="
                        (value) => validateInputNumStr(value, 'accidentNumber')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 报案号 -->
                <el-col :span="8">
                  <el-form-item label="报案号:" prop="reportNo">
                    <el-input
                      v-model="accidentForm.reportNo"
                      placeholder="请输入"
                      maxlength="30"
                      @input="(value) => validateInputNumStr(value, 'reportNo')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 付款方 -->
                <el-col :span="8">
                  <el-form-item label="付款方:" prop="payer">
                    <el-select
                      placeholder="请选择"
                      v-model="accidentForm.payer"
                      clearable
                    >
                      <el-option
                        v-for="item in plyerList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 付款日期 -->
                <el-col :span="8">
                  <el-form-item label="付款日期:" prop="payDate">
                    <el-date-picker
                      v-model="accidentForm.payDate"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <!-- 报案电话 -->
                <el-col :span="8">
                  <el-form-item label="报案电话:" prop="reportPhone">
                    <el-input
                      v-model="accidentForm.reportPhone"
                      placeholder="请输入"
                      maxlength="11"
                      v-interage
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!-- 驾驶人 -->
                <el-col :span="8">
                  <el-form-item label="驾驶人:" prop="driverName">
                    <el-input
                      v-model.trim="accidentForm.driverName"
                      placeholder="请输入"
                      v-delete-emoji
                      v-unspace
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="驾驶人联系方式:" prop="driverTel">
                    <el-input
                      v-model.number="accidentForm.driverTel"
                      placeholder="请输入"
                      v-interage
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 总行驶公里数 -->
                <el-col :span="8">
                  <el-form-item label="总行驶公里数:" prop="totalMileage">
                    <el-input
                      v-model="accidentForm.totalMileage"
                      placeholder="请输入"
                      v-number:km
                    >
                      <template slot="append">KM</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!-- 维修厂 -->
                <el-col :span="8">
                  <el-form-item label="维修厂:" prop="repairer">
                    <el-input
                      v-model.trim="accidentForm.repairer"
                      placeholder="请输入"
                      maxlength="20"
                      v-delete-emoji
                      v-unspace
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 安全员 -->
                <el-col :span="8">
                  <el-form-item label="安全员:" prop="securityOfficer">
                    <el-input
                      v-model.trim="accidentForm.securityOfficer"
                      placeholder="请输入"
                      v-delete-emoji
                      v-unspace
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 事故及进展描述 -->
                <el-col :span="8">
                  <el-form-item label="事故及进展描述:" prop="accidentDescribe">
                    <el-input
                      type="textarea"
                      v-model="accidentForm.accidentDescribe"
                      placeholder="请输入"
                      maxlength="500"
                      show-word-limit
                      :rows="2"
                      v-delete-emoji
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 备注 -->
                <el-col :span="8">
                  <el-form-item label="备注:" class="alone" prop="remarks">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入"
                      v-model="accidentForm.remarks"
                      maxlength="500"
                      show-word-limit
                      v-delete-emoji
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- 附件 -->
                <el-col :span="12">
                  <el-form-item label="保单附件/图片:" class="alone">
                    <UploadCommon
                      :fileList="fileList"
                      listType="text"
                      :limit="20"
                      :sizeType="4"
                      commonUpload
                      group="assert"
                      code="assert_guarantee_slip"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-collapse-item>
        </el-form>

        <el-collapse-item title="事故财务项" name="3">
          <!-- accidentForm.accidentStatus： 1-待处理 2-处理中 3-已完成 -->
          <FromMatching
            v-if="isSettlement && +accidentForm.accidentStatus === 3"
            :tableData="tableData"
            :headData="headData"
          ></FromMatching>
          <!-- 因为created里有用$refs  所以得用v-show 不然拿不到ref -->
          <AddFinanceItem
            v-show="!isSettlement"
            ref="AddFinanceItem"
            :allLossAmount="accidentForm.lossAmount"
            @lossAmountTotal="getLossAmountTotal"
            @receivableAmountTotal="getReceivableAmountTotal"
            @setRowLength="getRowLength"
          />
        </el-collapse-item>
        <el-collapse-item v-if="isSettlement" title="结算信息" name="4">
          <!-- 结算状态 已完成才展示 -->
          <QS-column-box
            label-width="140"
            :source="settlementSource.settlementVO"
            :column="3"
            :list="settlementList"
          />
        </el-collapse-item>
      </el-collapse>
      <template slot="bottomAction">
        <el-button @click="pageGoBack">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirmAdd">保存</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { FuzzySearch, getLastOrder } from '@/api/domain/cars'
import { accidentAdd, accidentDestail, accidentEdit } from '@/api/serviceAPi'
import selectOption from '@/store/dict/selectOptionDict'
import AddFinanceItem from './addFinanceItem'
import { validMobile } from '@/utils/validate.js'
import moment from 'moment'
import { cloneDeep, debounce } from 'lodash'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  data() {
    // 手机号校验
    const telValid = (_, value, callback) => {
      if (value && !validMobile(value)) {
        return callback(new Error('手机号格式错误'))
      } else return callback()
    }
    return {
      handleType: 'add',
      activeNames: ['1', '2', '3', '4'],
      accidentForm: {
        carId: '',
        brandName: '', // 品牌
        seriesName: '', // 车系
        carModelName: '', // 车型
        customerName: '', // 用户名
        customerId: '',
        contractId: '', // 当前订单Id
        plateNo: '', // 车牌号
        reportDate: '', // 报案日
        claimState: '', // 出险状态
        accidentDate: '', // 出险日期
        accidentType: '', // 事故类型
        accidentStatus: '', // 事故状态
        accidentBlame: '', // 事故责任
        insuranceType: [], // 保险类型
        lossAmount: '', // 定损金额
        claimAmount: '', // 理赔金额
        receivableAmount: '', // 应收金额
        customerInsuredAmount: '', // 客户承担担保金额
        accidentPlace: '', // 事故地点
        accidentNumber: '', // 事故单号
        reportNo: '', // 报案号
        payer: '', // 付款方
        payDate: '', // 付款日期
        reportPhone: '', // 报案电话
        driverName: '', // 驾驶人
        totalMileage: '', // 总行驶公里数
        repairer: '', // 维修厂
        accidentDescribe: '', // 事故及进展描述
        securityOfficer: '', // 安全员
        remarks: '', // 备注
        attachment: '', // 附件
        accidentItemsAddParamList: [],
        deductibleAmount: '', // 免赔金额
        repairAmount: '', // 维修金额
        accidentCauseCode: '', // 事故原因
        injurySituationCode: '', // 是否人伤
        driverTel: '', // 驾驶人联系方式
      },
      needParsePrams: [
        'lossAmount',
        'claimAmount',
        'receivableAmount',
        'customerInsuredAmount',
      ], // 需要转为分的字段
      loading: false,
      list: [
        {
          key: 'brandName',
          name: '品牌',
        },
        {
          key: 'seriesName',
          name: '车系',
        },
        {
          key: 'carModelName',
          name: '车型',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'contractId',
          name: '当前订单ID',
        },
        {
          key: 'customerName',
          name: '当前客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
      ],
      labelWidth: '120px',
      /* 上传假数据 */
      fileList: [],
      rules: {
        carId: [{ required: true, message: '不能为空', trigger: 'change' }],
        reportDate: [{ required: true, message: '不能为空', trigger: 'blur' }],
        accidentStatus: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        accidentDate: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        accidentType: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        accidentBlame: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        claimState: [
          { required: true, message: '不能为空', trigger: 'change' },
        ],
        reportPhone: [
          { min: 11, max: 11, message: '格式不正确', trigger: 'blur' },
        ],
        driverTel: [{ required: false, validator: telValid, trigger: 'blur' }],
      },
      headData: [
        {
          prop: 'item',
          label: '类型',
        },
        {
          prop: 'lossAmount',
          label: '定损金额',
          event: (val) => this.numberWithCommas(val),
        },
        {
          prop: 'receivableTypeName',
          label: '应收收取方式',
        },
        {
          prop: 'receivableProportionName',
          label: '应收占比',
        },
        {
          prop: 'receivableAmount',
          label: '应收金额',
          event: (val) => this.numberWithCommas(val),
        },
        {
          prop: 'remarks',
          label: '备注',
        },
      ],
      tableData: [],
      settlementSource: {},
      settlementList: [
        {
          key: 'content',
          name: '收款内容:',
        },
        {
          key: 'receivableDate',
          name: '收款时间:',
        },
        {
          key: 'settlementStatusName',
          name: '结算状态',
        },
        {
          key: 'customerType',
          name: '付款方类型:',
        },
        {
          key: 'customerName',
          name: '付款方:',
        },
        {
          key: 'remarks',
          name: '备注:',
        },
      ],
      rowLength: 0,
    }
  },
  components: { AddFinanceItem },
  created() {
    ['car_to_lease_list_accident', 'vehicle_accident_list_create'].includes(this.$route.name)
      ? (this.handleType = 'add')
      : (this.handleType = 'edit')
    if (this.isEditType) {
      accidentDestail({
        id: this.$route.query.id,
      }).then(({ data }) => {
        this.source = { ...data }
        this.settlementSource = { ...data }
        this.tableData = this.source.accidentItemsAddParamList
        Object.keys(this.accidentForm).forEach((key) => {
          if (data[key]) {
            this.accidentForm[key] = data[key]
          }

          if (
            this.needParsePrams.includes(key) &&
            data[key] !== '' &&
            data[key] !== null &&
            typeof data[key] !== 'undefined'
          ) {
            this.accidentForm[key] = this.parseMoney(data[key])
          }
          // 保险类型
          if (key === 'insuranceType') {
            this.accidentForm[key] = data[key]
              ? data[key].split(',').map((item) => Number(item))
              : []
          }
        })
        this.fillBackFinance()
        this.fileList = this.getEchoUploadFileData(data.attachment, true)
      })
    }
  },
  mounted() {
    if (this.$route.query.plateNo !== undefined) {
      this.accidentForm.plateNo = this.$route.query.plateNo
    }
  },
  activated() {
    document.querySelector('#app-main').scrollTo({ top: 0, behavior: 'smooth' })
  },
  methods: {
    // 回填数据财务项
    fillBackFinance() {
      const arr = cloneDeep(this.accidentForm?.accidentItemsAddParamList || [])
      this.getRowLength(arr.length)
      if (!arr.length) return
      arr.forEach((item) => {
        if (
          item.receivableAmount !== '' &&
          item.receivableAmount !== null &&
          typeof item.receivableAmount !== 'undefined'
        ) {
          item.receivableAmount = this.parseMoney(item.receivableAmount)
        }
        if (
          item.lossAmount !== '' &&
          item.lossAmount !== null &&
          typeof item.lossAmount !== 'undefined'
        ) {
          item.lossAmount = this.parseMoney(item.lossAmount)
        }
      })
      this.$refs.AddFinanceItem.formModel.formDataaccidentItemsAddParamList =
        arr
    },
    // 获取定损金额
    getLossAmountTotal(val) {
      this.accidentForm.lossAmount =
        Number(val) === 0 ? '' : this.parseMoney(val.toFixed(2))
    },
    // 获取应付金额
    getReceivableAmountTotal(val) {
      this.accidentForm.receivableAmount =
        Number(val) === 0 ? '' : this.parseMoney(val.toFixed(2))
    },
    // 获取财务项个数
    getRowLength(val) {
      this.rowLength = val
    },
    /* 选择车牌号 */
    selectPlateNo(id, carInfo) {
      this.accidentForm.carModelName = carInfo?.modelName || ''
      this.accidentForm.plateNo = carInfo?.plateNo || ''
      this.accidentForm.brandName = carInfo?.brandName || ''
      this.accidentForm.seriesName = carInfo?.seriesName || ''
      if (this.accidentForm.carId) {
        this.contractList(this.accidentForm)
      } else {
        this.accidentForm.customerId = ''
        this.accidentForm.customerName = ''
        this.accidentForm.contractId = ''
      }
    },
    // 获取车牌号对应的合同信息
    async contractList() {
      try {
        const res = await getLastOrder({
          carId: this.accidentForm.carId,
        })
        if (res.code === 1) {
          this.accidentForm.customerId = res.data?.customerId
          this.accidentForm.customerName = res.data?.customerName
          this.accidentForm.contractId = res.data?.id
        }
      } catch (error) {
        console.log('accident_error', error)
      }
    },
    parseMoney(num) {
      return String(Number(num))
    },
    /* 确定新增 */
    confirmAdd() {
      const financeState = this.$refs.AddFinanceItem.validateFinance()
      let formState = false
      this.$refs.sourceList.validate((vaild) => {
        if (vaild) {
          formState = true
        } else {
          formState = false
          this.$message.error('请确认表单项是否填写正确')
        }
      })
      if (financeState && formState) {
        this.accidentForm.attachment = this.getUoloadCommonFileData(
          this.fileList,
        )
        // 格式化财务项
        const accidentItemsAddParamList = cloneDeep(this.$refs.AddFinanceItem?.formModel
          ?.formDataaccidentItemsAddParamList || [])
        accidentItemsAddParamList.forEach((item) => {
          item.carId = this.accidentForm.carId
          item.lossAmount = this.parseMoney(item.lossAmount)
          item.receivableAmount = this.parseMoney(item.receivableAmount)
        })
        if (this.isAddType) {
          this.addAccident({
            ...this.accidentForm,
            insuranceType: this.accidentForm.insuranceType.join(','),
            accidentItemsAddParamList,
          })
        } else {
          delete this.accidentForm.accidentItemsAddParamList
          this.editAccident({
            ...this.accidentForm,
            id: this.$route.query.id,
            insuranceType: this.accidentForm.insuranceType.join(','),
            accidentItemsEditParams: accidentItemsAddParamList,
          })
        }
      }
    },
    // 新增事故接口
    async addAccident(params) {
      this.loading = true
      accidentAdd(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success('操作成功')
            this.$refreshBack(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 页面提交事件
    async editAccident(params) {
      this.loading = true
      accidentEdit(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success('操作成功')
            this.pageGoBack(true)
            this.sendMessage()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消，返回上一页
    pageGoBack: debounce(function (status = false) {
      this.$refreshBack(status)
    }, 500),
    // 事故定损金额change
    lossAmountChange(value) {
      this.$refs.AddFinanceItem.formModel.formDataaccidentItemsAddParamList &&
        this.$refs.AddFinanceItem.formModel.formDataaccidentItemsAddParamList.forEach(
          (item) => {
            item.lossAmount = value || '--'
          },
        )
    },
    // 仅允许输入字母数字
    validateInputNumStr(value, key) {
      let _value = ''
      _value = value.replace(/\W/g, '')
      this.$set(this.accidentForm, key, _value)
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
  computed: {
    // 当前页面状态管理
    // 是否为新增态
    isAddType() {
      return this.handleType === 'add'
    },
    // 是否为编辑态
    isEditType() {
      return this.handleType === 'edit'
    },
    // 是否已经发起结算
    isSettlement() {
      return (
        this.settlementSource &&
        this.settlementSource.settlementVO &&
        this.settlementSource.settlementVO.settlementStatus !== null
      )
    },
    // 事故状态列表
    accidentStatusList() {
      return this.dictParseList(selectOption.accidentStatusDict)
    },

    // 出险状态列表
    outInsuranceStatusList() {
      return this.dictParseList(selectOption.outInsuranceStatusDict)
    },

    // 事故类型列表
    accidentTypeList() {
      return this.dictParseList(selectOption.accidentTypeDict)
    },
    // 事故责任列表
    accidentResponsibilityList() {
      return this.dictParseList(selectOption.accidentResponsibilityDict)
    },
    // 保险类型
    insuranceTypeList() {
      const filterObj = { ...selectOption.insuranceTypeDict }
      // 在新建、编辑事故中不需要展示「车船税」，产品需求
      delete filterObj[5]
      return this.dictParseList(filterObj)
    },
    plyerList() {
      return this.dictParseList(selectOption.plyers)
    },
    // 出险日选择范围
    accidentDateOption() {
      // 出险日期 > 报案日期且只能选择当天以前（包含当天）
      return {
        disabledDate: (time) => {
          if (this.accidentForm.reportDate) {
            return moment(time).isBefore(moment(this.accidentForm.reportDate)) || time.valueOf() > moment().valueOf()
          }
          return time && time.valueOf() > moment().valueOf()
        },
      }
    },
    // 报案日选择范围
    reportDataOption() {
      return {
        disabledDate: (time) => {
          if (!this.accidentForm.accidentDate) {
            return time && time.valueOf() > moment().valueOf()
          }
          return moment(time).isAfter(moment(this.accidentForm.accidentDate))
        },
      }
    },
    // 事故原因列表
    accidentReasonList() {
      return this.dictParseList(selectOption.accidentReason)
    },
    // 是否人伤
    accidentPersonInjuryList() {
      return this.dictParseList(selectOption.accidentPersonInjury)
    },
  },
}
</script>
<style lang="less" scoped>
.s-title {
  font-size: 16px;
  color: #303133;
  margin: 16px 0;
}
.infor,
.dialogWrap {
  ::v-deep .el-input--small {
    width: 220px;
  }
  .columnBox {
    ::v-deep .column_content_mrbtm {
      align-items: center;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
.add_accident {
  ::v-deep .el-collapse {
    border-bottom: none;
    border-top: none;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__header {
    border-top: 1px solid #ececf4;
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
  ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
}
</style>
